import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API } from 'src/app/configs/api.config';
import { Subject, Observable } from 'rxjs';


@Injectable()
export class UserManagerService {

  total;
  users;

  contentChange = new Subject;

  constructor(
    private http: HttpClient,
  ) { }

  getUserList(page) {
    return this.http.get<ResponseModel>(API.USER, {
      params: {
        page: page.pageNumber + 1,
        perPage: page.size
      }
    })
  }

  getUserInfo(userId) {
    return this.http.get<ResponseModel>(API.USER + '/' + userId)
  }

  searchUser(page, keyword) {
    return this.http.get<ResponseModel>(API.USER + '/search', {
      params: {
        keyword: keyword,
        page: page.pageNumber + 1,
        perPage: page.size
      }
    })
  }

  searchUserBydeviceId(page, deviceId) {
    return this.http.get<ResponseModel>(API.USER + '/search', {
      params: {
        deviceId: deviceId,
        page: page.pageNumber + 1,
        perPage: page.size
      }
    })
  }

  changeUserGroup(user, group, expire) {
    return this.http.put<ResponseModel>(API.USER + '/group', {
      userId: user,
      groupId: group,
      expireAt: expire
    })
  }

  changeUserDeviceNum(user, dtype, deviceNum) {
    return this.http.put<ResponseModel>(API.USER + '/perm/devicenum', {
      userId: user,
      addType: dtype,//diy,pro
      num: deviceNum
    })
  }

  changeUserDataKeyNum(user, datakeyNum) {
    return this.http.put<ResponseModel>(API.USER + '/perm/datakeynum', {
      userId: user,
      num: datakeyNum
    })
  }

  deleteUser(userId) {
    return this.http.delete<ResponseModel>(API.USER, {
      params: {
        userId: userId
      }
    })
  }

  // return {"messages": 1000, "detail": {"password": ""}}
  restUserPassword(userId) {
    return this.http.post<ResponseModel>(API.USER + '/password', {
      userId: userId
    })
  }

  // return {"messages": 1000, "detail": {"phone": "", "password": ""}}
  addNewUser(phone) {
    return this.http.post<ResponseModel>(API.USER, {
      phone: phone
    })
  }

  setUserVender(userId, vender) {
    return this.http.post<ResponseModel>(API.USER + "/auth", {
      userId: userId,
      vender: vender
    })
  }

}
